export enum AlertType {
  LowAverageRating,
  SpecificRating,
  LateForm,
  TrainingTime,
  PercentageRating,
  PhaseLength,
  PhaseAdditionalHours,
  LateQuiz,
  IncidentWarning,
  NRT,
  UpcomingForm
}
